import {
  type PurchaseContractColumnsMode,
  useGetPurchaseContractColumnsPreferenceQuery,
  usePutPurchaseContractColumnsPreferenceMutation,
} from '../../store/api/purchaseContractApi'
import {
  useDatasheetColumns,
  type ColumnsPreferencePutArg,
} from '../../utils/datasheetColumns/useDatasheetColumns'
import type { DatasheetColumnLike, UseDatasheetColumnsMenuResult } from '../../utils/datasheetColumns/types'

export interface UsePurchaseContractColumnsParams<TCol extends DatasheetColumnLike> {
  mode: PurchaseContractColumnsMode
  allColumns: TCol[]
  storageKey: string
}

export function usePurchaseContractColumns<TCol extends DatasheetColumnLike>(
  params: UsePurchaseContractColumnsParams<TCol>,
): UseDatasheetColumnsMenuResult<TCol> {
  const preferenceQuery = useGetPurchaseContractColumnsPreferenceQuery(params.mode)
  const [putColumnsPreference] = usePutPurchaseContractColumnsPreferenceMutation()
  return useDatasheetColumns({
    mode: params.mode,
    allColumns: params.allColumns,
    storageKey: params.storageKey,
    preferenceQuery,
    putPreference: (arg: ColumnsPreferencePutArg<PurchaseContractColumnsMode>) =>
      putColumnsPreference(arg),
  })
}
